import {
  createStartAction,
  createSuccessAction,
} from '../../redux-util/async-helpers';
import { CREATE_PAGE_VIEWER } from '../../redux-jigsaw/jigsaw-methods';
import {
  LIST_ACTIVE_ASSETS,
  LIST_ADOPTION_ASSETS,
  LIST_ALL_ASSETS,
  SEARCH_ASSETS,
  UPDATE_ADOPTION_ASSETS,
} from '../bridge-method-remap';
import {
  DELETE_ADOPTION,
  LIST_ASSETS_MULTI,
} from 'app/api/redux-bridge/bridge-methods';

const actions = [
  LIST_ALL_ASSETS,
  SEARCH_ASSETS,
  LIST_ACTIVE_ASSETS,
  LIST_ADOPTION_ASSETS,
];

const successes = actions.map(a => createSuccessAction(a).type);

function fixAdoptions(adoptions) {
  if (!adoptions) {
    return [];
  }
  // Bridge returns ints, but the UI is sometimes dealing in strings
  // e.g. through the URL or input element attributes. Make them all
  // strings so that comparisons work
  return adoptions.map(a => `${a}`);
}

export default function assetsReducer(state = {}, action) {
  const newState = { ...state };
  if (successes.indexOf(action.type) !== -1) {
    action.data.content.forEach(d => {
      newState[d.vbid] = {
        ...d,
        adoptions: fixAdoptions(d.adoptions),
      };
    });
    return newState;
  } else if (action.type === createSuccessAction(CREATE_PAGE_VIEWER).type) {
    const fakeBook = {
      vbid: action.data.isbn,
      title: action.data.title,
      author: action.data.author,
      description: '',
      coverImageUrl: null,
      active: true,
      adoptions: [],
    };
    newState[fakeBook.vbid] = fakeBook;
    return newState;
  } else if (action.type === createSuccessAction(UPDATE_ADOPTION_ASSETS).type) {
    const adoptions = action.args[0].adoptions;
    adoptions.forEach(adoption => {
      const adoptionId = `${adoption.id}`;
      adoption.assets.forEach(asset => {
        if (newState[asset.vbid]) {
          const oldAdoptions = newState[asset.vbid].adoptions || [];
          const index = oldAdoptions.indexOf(adoptionId);
          if (asset.assigned && index === -1) {
            newState[asset.vbid] = {
              ...newState[asset.vbid],
              adoptions: [...oldAdoptions, adoptionId],
            };
          } else if (!asset.assigned && index !== -1) {
            const updatedAdoptions = [...oldAdoptions];
            updatedAdoptions.splice(index, 1);
            newState[asset.vbid] = {
              ...state[asset.vbid],
              adoptions: updatedAdoptions,
            };
          }
        }
      });
    });
    return newState;
  } else if (action.type === createStartAction(DELETE_ADOPTION).type) {
    Object.keys(state).forEach(vbid => {
      const data = state[vbid];
      const index = data.adoptions.indexOf(`${action.data[0].id}`);
      if (index !== -1) {
        const adoptions = [...data.adoptions];
        adoptions.splice(index, 1);
        newState[vbid] = {
          ...data,
          adoptions,
        };
      }
    });
    return newState;
  } else if (action.type === createSuccessAction(LIST_ASSETS_MULTI).type) {
    const newState = { ...state };
    action.data.lists.forEach(list => {
      if (list.content) {
        list.content.forEach(asset => {
          newState[asset.vbid] = {
            ...asset,
            adoptions: fixAdoptions(asset.adoptions),
          };
        });
      }
    });
    return newState;
  }
  return state;
}
